import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';

interface BottomBarProps {
  tong_tien: number;
  thue: number;
  ty_gia?: number;
}

export function BottomBar({ tong_tien, thue, ty_gia = 1 }: BottomBarProps) {
  return (
    <div className='flex w-full items-start justify-between px-4 py-2'>
      {/* Left Column */}
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between gap-2'>
          <span className='w-32 text-sm font-bold text-gray-800'>Tổng tiền</span>
          <FormField type='text' name='t_tien_nt2' value={formatRoundedNumber(tong_tien)} className='font-medium' />
          <FormField
            type='text'
            name='t_tien2'
            value={formatRoundedNumber(tong_tien * ty_gia)}
            className={`${ty_gia == 1 && 'hidden'} font-medium`}
          />
        </div>
        <div className='flex items-center justify-between gap-2'>
          <span className='w-32 text-sm font-bold text-gray-800'>Tổng thuế</span>
          <FormField type='text' name='t_thue_nt' value={formatRoundedNumber(thue)} className='font-medium' />
          <FormField
            type='text'
            name='t_thue'
            value={formatRoundedNumber(thue * ty_gia)}
            className={`${ty_gia == 1 && 'hidden'} font-medium`}
          />
        </div>
      </div>

      {/* Right Column */}
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between gap-2'>
          <span className='w-32 text-sm font-bold text-gray-800'>Tổng thanh toán</span>
          <FormField type='text' name='t_tt_nt' value={formatRoundedNumber(tong_tien + thue)} className='font-medium' />
          <FormField
            type='text'
            name='t_tt'
            value={formatRoundedNumber((tong_tien + thue) * ty_gia)}
            className={`${ty_gia == 1 && 'hidden'} font-medium`}
          />
        </div>
      </div>
    </div>
  );
}

export default BottomBar;
